'use client';
import React from 'react';
import { LocaleType, LOCALES } from '@benzinga/translate';
import { getGlobalConfig } from '../utils/config';
import { DEFAULT_CONFIG } from '../config/global/default';
import { GlobalNavigationConfig } from '../entities';

interface IdentityProps {
  config: GlobalNavigationConfig;
  host: string;
  language: LocaleType;
}

export const IdentityContext = React.createContext<IdentityProps>({
  config: DEFAULT_CONFIG,
  host: '',
  language: LOCALES.EN,
});

export type IdentityContextType = React.ContextType<typeof IdentityContext>;

export const IdentityContextProvider: React.FC<React.PropsWithChildren<Partial<IdentityProps>>> = React.memo(props => {
  const value = React.useMemo<IdentityProps>(() => {
    const language = props.language ?? LOCALES.EN;
    const host = props.host ?? 'www.benzinga.com';

    const config = getGlobalConfig(host, language);

    return {
      config: config ?? DEFAULT_CONFIG,
      host: props.host ?? 'www.benzinga.com',
      language: props.language ?? LOCALES.EN,
    };
  }, [props.host, props.language]);

  return <IdentityContext.Provider value={value}>{props.children}</IdentityContext.Provider>;
});

IdentityContextProvider.displayName = 'IdentityContextProvider';
